import React from 'react';
import PropTypes from 'prop-types';

import './checkbox.scss';

function Checkbox({checked, toggle, disabled = false, label}) {
    function renderLabel() {
        if (!label) {
            return null;
        }

        return (
            <div className={"mindsets-checkbox-label" + (disabled ? ' disabled' : '')}>{label}</div>
        );
    }

    return (
        <div className="mindsets-checkbox" onClick={!disabled ? toggle : null}>
            <div
                className={'mindsets-checkbox-tick' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '')}/>
            {renderLabel()}
        </div>
    );
}

Checkbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.element
    ]),
    toggle: PropTypes.func.isRequired
};

export default Checkbox;
